/*
 * For state that doesn't yet have a home
 */

import { State } from 'jumpstate'
import ValueState from './lib/ValueState'
import SyncState from './lib/SyncState'

export { SyncState, ValueState }

export const states = new Map()

export function registerState (name, state) {
  const existing = states.get(name)
  if (existing) return existing
  states.set(name, state)
  return state
}

export function useState (name, ...args) {
  const existing = states.get(name)
  if (existing) return existing
  const state = registerState(name, State(name, ...args))
  return state
}

export function useValueState (name, ...args) {
  const existing = states.get(name)
  if (existing) return existing
  const state = registerState(name, ValueState(name, ...args))
  return state
}

const Config = State('config', {
  initial: {
    isReady: false
  },
  setConfig (state, payload) {
    return Object.assign({}, state, payload, {
      isReady: true
    })
  }
})

const Samples = SyncState('sample')
const Tasks = SyncState('task')
const Jobs = SyncState('job')

const MDSS = SyncState('mdss')
const Samplesets = ValueState('samplesets', { list: [] })
const Datasets = ValueState('datasets')
const DatasetsTasks = ValueState('datasetsTasks')

export {
  Config,
  Samples,
  Samplesets,
  MDSS,
  Tasks,
  Jobs,
  Datasets,
  DatasetsTasks
}



// WEBPACK FOOTER //
// ../webmango-core/state/index.js